// ** Type Imports
import { OwnerStateThemeType } from "../";

const Menu = () => {
  const boxShadow = (theme: OwnerStateThemeType["theme"]) => {
    return theme.shadows[9];
  };

  return {
    MuiMenu: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          "& .MuiMenu-paper": {
            borderRadius: 5,
            boxShadow: boxShadow(theme),
            backgroundColor: theme.palette.background.paper,
          },
        }),
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          "&:hover": {
            backgroundColor: `${theme.palette.primary.light} !important`,
          },
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.light,
          },
        }),
      },
    },
  };
};

export default Menu;
